import { defineStore } from 'pinia'
export default defineStore({
  id: 'companyGroupDataTable',
  persist: true,
  state: () => {
    return {
      isCompanyGroupArchive: false
    }
  },
  actions: {
    setIsCompanyGroupArchive: function (payload: any) {
      this.isCompanyGroupArchive = payload
    }
  },
  getters: {
    getIsCompanyGroupArchive: (state: any) => state.isCompanyGroupArchive
  }
})
